import { Row } from "../../../Basic/Blocks";
import { Select } from "../../../Basic/Inputs";

export const FRONT_ERRORS = {
  null: { message: 'Не выбран', level: 1 },
  not_found_provider_product: { message: 'Не найден товар поставщика' },
  bad_provider_product: { message: 'Неккоректный товар поставщика' },
  not_found_warehouse_product: { message: 'Не найден товар на складе' },
  bad_warehouse_product: { message: 'Неккоректная карточка склада' },

  bad_quantity: { message: 'Некорректное количество товара' },
  bad_min_quantity: { message: 'Некорректное мин. кол-во товара' },
  bad_volume: { message: 'Некорректный объем' },
  bad_purchase: { message: 'Неккоректная цена закупки' },
  bad_nds: { message: 'Неккоректная НДС' },

  bad_commission: { message: 'Неккоректный просчёт коммиссии' },
  bad_commission_nds: { message: 'Неккоректный просчёт коммиссии c ндс' },
  bad_price_calc: { message: 'Просчитанная цена содержит ошибку' },
  bad_profit: { message: 'Некорректный подсчёт профита' },
  high_diff_price: { message: 'Высокая разница цен' },
  purchase_distrust: { message: 'Подозрительная цена закупки' },

  bad_provider_id: { message: 'Некорректный поставщик' },
  not_exists_provider_artnumber: { message: 'Не указан артикул поставщика' },

  error_load_price: { message: 'Не удалось выгрузить информацию по комиссиям и квантам' },
};

export const FRONT_WARNING = {
  null: { message: 'Не выбран', level: 1 },
  bad_volume: { level: 2, message: 'Некорректный объем' },
  bad_nds: { level: 2, message: 'Некорректный НДС' },
  not_found_warehouse_product: { level: 2, message: 'Не найден товар на складе' },
  bad_warehouse_product: { level: 2, message: 'Неккоректная карточка склада' },
};

const MarketsFilter = ({
  show = 50,
  tab = 0,
  sortType,
  SORT_TYPE,
  provider,
  providers = [],
  error,
  setShow = (_) => _,
  setError = (_) => _,
  setWarning = (_) => _,
  changeProvider = (_) => _,
  setSortType = (_) => _,
  selectTab,
  errorsGroup = {},
  warningsGroup = {},
}) => {
  return (
    <Row>
      <Select
        label="Показать на странице"
        select={show}
        list={['50', '100', '150', '200', '500', '1000']}
        onSelect={(v) => setShow(v)}
        width="150px"
        style={{ marginRight: '15px' }}
      />
      <Select
        label="Поставщик"
        select={provider}
        valueFn={(p) => p.name}
        list={providers}
        width="200px"
        onSelect={(v) => changeProvider(v)}
        style={{ marginRight: '15px' }}
      />
      {sortType && (<Select
        label="Сортировка"
        select={sortType}
        valueFn={(p) => p.name}
        list={SORT_TYPE}
        width="200px"
        style={{ marginRight: '15px' }}
        onSelect={(v) => setSortType(v)}
      />)}
      {selectTab === 'error' && (
        <Select
          label="Тип ошибки"
          select={error}
          valueFn={(p) => `${FRONT_ERRORS[p]?.message} - ${errorsGroup[p] || ''}`}
          list={['null', ...Object.keys(FRONT_ERRORS).filter((p) => errorsGroup[p] > 0)]}
          width="400px"
          onSelect={(v) => setError(v)}
          style={{ marginRight: '15px' }}
        />
      )}
      {selectTab === 'warning' && (
        <Select
          label="Тип предупреждения"
          select={error}
          valueFn={(p) => `${FRONT_WARNING[p]?.message} ${warningsGroup[p] || ''}`}
          list={Object.keys(FRONT_WARNING)}
          width="400px"
          onSelect={(v) => setWarning(v)}
          style={{ marginRight: '15px' }}
        />
      )}
    </Row>
  );
};

export default MarketsFilter;
